import { IVisualSearchState, initialVisualSearchState, VisualSearchActions } from "src/share/types/visualSearch";

function visualSearchReducer(state: IVisualSearchState, action) {
  switch (action.type) {
    case VisualSearchActions.setProvider:
      return { ...state, provider: action.payload, providerModalToggle: false };
    case VisualSearchActions.setThumbnail:
      return { ...state, thumbnail: action.payload.image, by: action.payload.by };
    case VisualSearchActions.setFace:
      return { ...state, selectedFace: action.payload };
    case VisualSearchActions.setFaces:
      return { ...state, faces: action.payload, showFaceModal: true, isFaceLoading: false };
    case VisualSearchActions.setLoading:
      return { ...state, isLoading: true, isFaceLoading: false, images: [], error: "", showFaceModal: false };
    case VisualSearchActions.setFaceLoading:
      return { ...state, isFaceLoading: true, images: [], selectedFace: "" };
    case VisualSearchActions.setFetchingData:
      return { ...state, fetchingData: true, isLoading: !state.offset };
    case VisualSearchActions.setImages:
      return { ...state, images: action.payload, isLoading: false, isFaceLoading: false };
    case VisualSearchActions.addImages:
      return {
        ...state,
        images: [...state.images, ...action.payload.results],
        offset: action.payload.offset,
        total: action.payload.total,
        fetchingData: false,
        isLoading: false
      };
    case VisualSearchActions.toggleProviderModal:
      return { ...state, providerModalToggle: !state.providerModalToggle };
    case VisualSearchActions.toggleFaceModal:
      return { ...state, showFaceModal: !state.showFaceModal, isFaceLoading: false, thumbnail: "" };
    case VisualSearchActions.error:
      return { ...state, isLoading: false, isFaceLoading: false, isFetchingData: false, error: action.payload };
    case VisualSearchActions.reset:
      return { ...initialVisualSearchState, thumbnail: state.thumbnail, by: state.by };
    default:
      throw new Error("Selected action is not implemented");
  }
}

export default visualSearchReducer;



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/state/reducer.ts